import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/components/store/icons";
import { ProductRow, ProductGrid } from "@/components/store/ProductRow";

export default function Category() {
  const { key } = useParams();
  const [cats, setCats] = useState([]);
  const [cat, setCat] = useState(null);
  const [products, setProducts] = useState([]);
  const [best, setBest] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);

  useEffect(() => {
    const c = cats.find((x) => x.key === key);
    setCat(c);
    if (!cats.length) return;
    setLoading(true);
    const sp = new URLSearchParams();
    if (c?.query_category) sp.set("category", c.query_category);
    else if (c?.query_q) sp.set("q", c.query_q);
    sp.set("limit", "30");
    api.get(`/products?${sp.toString()}`).then((r) => {
      let items = r.data.items;
      if (items.length === 0) {
        api.get("/products?sort=best_selling&limit=30").then((rr) => setProducts(rr.data.items));
      } else setProducts(items);
    }).finally(() => setLoading(false));
    api.get(`/products?${c?.query_category ? "category=" + c.query_category + "&" : ""}sort=best_selling&limit=12`).then((r) => setBest(r.data.items));
  }, [key, cats]);

  const subcats = cats.filter((c) => c.key !== key).slice(0, 8);

  return (
    <div className="bg-[#F1F3F6] min-h-screen">
      <div className="max-w-[1500px] mx-auto px-4 py-4 space-y-4">
        {/* Banner */}
        <div className="relative rounded-md overflow-hidden min-h-[160px] bg-gradient-to-r from-[#101A3D] to-[#2a3a7a] flex items-center px-8">
          {cat && <img src={cat.image} alt="" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-30" />}
          <div className="relative z-10">
            <p className="text-white/70 text-xs flex items-center gap-1"><Link to="/" className="hover:text-white">Home</Link> / {cat?.name || key}</p>
            <h1 className="text-white font-display text-3xl lg:text-4xl font-extrabold mt-1 flex items-center gap-3">
              {cat && <Icon name={cat.icon} size={30} className="text-[#FF6A1A]" />}{cat?.name || "Category"}
            </h1>
            <p className="text-white/80 text-sm mt-1">{products.length}+ products available</p>
          </div>
        </div>

        {/* Subcategories */}
        <div className="bg-white rounded-md border border-zinc-200 p-4">
          <h3 className="font-semibold text-sm mb-3">Browse Categories</h3>
          <div className="flex gap-3 overflow-x-auto scrollbar-hide">
            {subcats.map((c) => (
              <Link key={c.key} to={`/category/${c.key}`} className="flex flex-col items-center gap-1.5 shrink-0 w-20 group">
                <div className="w-16 h-16 rounded-full overflow-hidden border border-zinc-200 group-hover:border-[#FF6A1A]"><img src={c.image} alt="" className="w-full h-full object-cover" /></div>
                <span className="text-[10px] text-center text-zinc-600 line-clamp-2">{c.name}</span>
              </Link>
            ))}
          </div>
        </div>

        {best.length > 0 && <ProductRow title={`Best Sellers in ${cat?.name || ""}`} products={best} accent />}

        <div className="bg-white rounded-md border border-zinc-200 p-4">
          <h2 className="font-display text-lg font-bold mb-4">All {cat?.name || "Products"}</h2>
          {loading ? <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">{Array(12).fill(0).map((_, i) => <div key={i} className="aspect-[3/4] bg-zinc-100 rounded-md animate-pulse" />)}</div>
            : <ProductGrid products={products} />}
        </div>
      </div>
    </div>
  );
}
